import { render, staticRenderFns } from "./section-group-node.vue?vue&type=template&id=8aa86b52&"
import script from "./section-group-node.vue?vue&type=script&lang=js&"
export * from "./section-group-node.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports